import React from 'react';
import './App.css';
import MainMenu from './components/MainMenu'
function App() {
  return (
    <div className="App">
      <MainMenu />
    </div>
  );
}

export default App;
